import React from "react";

import HeaderTop from "../Header/HeaderTop";
import NavBar from "../Header/NavBar";
import AdminNavBar from "../Header/AdminNavBar";
import HeaderBottom from "../Header/HeaderBottom";

const Header = () => {
  return (
    <div>
      <HeaderTop />
      <NavBar />
      <AdminNavBar />
      <HeaderBottom />
    </div>
  );
};

export default Header;
